module.exports = __webpack_public_path__ + "img/RedteaGo.7dd25538.png";